module.exports = __webpack_public_path__ + "static/media/v1.9def254.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/a-view-outside/v1.mp4
// module id = 6LCy
// module chunks = 0